import { render, staticRenderFns } from "./withdrawDetail.vue?vue&type=template&id=da1b53d4&scoped=true&"
import script from "./withdrawDetail.vue?vue&type=script&lang=js&"
export * from "./withdrawDetail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawDetail.vue?vue&type=style&index=0&id=da1b53d4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1b53d4",
  null
  
)

export default component.exports